import React from 'react';
import GuestSpeakerView from './GuestSpeakerView';

export function GuestSpeakerContainer() {
	return (
		<div>
			<GuestSpeakerView />
		</div>
	);
}
